let selectedOption,
  collectionDropdown = document.querySelector("#collection-list select"),
  productsDropdowns = document.querySelectorAll("#product-lists select");
collectionDropdown.addEventListener("change", () => {
  hideCalc();
  let e = `collection-${collectionDropdown.value}`;
  productsDropdowns.forEach((n) => {
    e === n.id ? n.classList.remove("div-none") : n.classList.add("div-none");
  });
}),
  productsDropdowns.forEach((e) => {
    e.addEventListener("change", () => {
      hideCalc(),
        e.querySelectorAll("option").forEach((n) => {
          n.value === e.value && (selectedOption = n);
        });
    });
  });
let calcForm = document.querySelector("form#greencycle-calc"),
  result = document.querySelector("#result p"),
  areaCalculatorSelector = document.querySelector(".area-1 .area-calculator"),
  inputContainer = document.querySelector(".area-1 .inputContainer"),
  inputOne = document.querySelector(".area-1 .inputOne"),
  inputTwo = document.querySelector(".area-1 .inputTwo"),
  singleSqrFt = document.querySelector(".area-1 .single-area-coverage") || null,
  singleSqrFtSpan =
    document.querySelector(".area-1 .single-area-coverage span") || null;
areaCalculatorSelector.addEventListener("change", () => {
  inputContainer.classList.contains("div-none") &&
    inputContainer.classList.remove("div-none"),
    selectorReview(areaCalculatorSelector.value),
    (result.innerText = ""),
    null == document.querySelector(".calculator--pdp-modal-input") &&
      hideCalc();
});
let a2_areaCalculatorSelector =
    document.querySelector(".area-2 .area-calculator") || null,
  a2_inputContainer = document.querySelector(".area-2 .inputContainer") || null,
  a2_inputOne = document.querySelector(".area-2 .inputOne") || null,
  a2_inputTwo = document.querySelector(".area-2 .inputTwo") || null,
  a2_singleSqrFt =
    document.querySelector(".area-2 .single-area-coverage") || null,
  a2_singleSqrFtSpan =
    document.querySelector(".area-2 .single-area-coverage span") || null;
null != a2_areaCalculatorSelector &&
  a2_areaCalculatorSelector.addEventListener("change", () => {
    a2_inputContainer.classList.contains("div-none") &&
      a2_inputContainer.classList.remove("div-none"),
      a2_selectorReview(a2_areaCalculatorSelector.value),
      (result.innerText = "");
  });
let a3_areaCalculatorSelector =
    document.querySelector(".area-3 .area-calculator") || null,
  a3_inputContainer = document.querySelector(".area-3 .inputContainer") || null,
  a3_inputOne = document.querySelector(".area-3 .inputOne") || null,
  a3_inputTwo = document.querySelector(".area-3 .inputTwo") || null,
  a3_singleSqrFt =
    document.querySelector(".area-3 .single-area-coverage") || null,
  a3_singleSqrFtSpan =
    document.querySelector(".area-3 .single-area-coverage span") || null;
null != a3_areaCalculatorSelector &&
  a3_areaCalculatorSelector.addEventListener("change", () => {
    a3_inputContainer.classList.contains("div-none") &&
      a3_inputContainer.classList.remove("div-none"),
      a3_selectorReview(a3_areaCalculatorSelector.value),
      (result.innerText = "");
  });
let a4_areaCalculatorSelector =
    document.querySelector(".area-4 .area-calculator") || null,
  a4_inputContainer = document.querySelector(".area-4 .inputContainer") || null,
  a4_inputOne = document.querySelector(".area-4 .inputOne") || null,
  a4_inputTwo = document.querySelector(".area-4 .inputTwo") || null,
  a4_singleSqrFt =
    document.querySelector(".area-4 .single-area-coverage") || null,
  a4_singleSqrFtSpan =
    document.querySelector(".area-4 .single-area-coverage span") || null;
null != a4_areaCalculatorSelector &&
  a4_areaCalculatorSelector.addEventListener("change", () => {
    a4_inputContainer.classList.contains("div-none") &&
      a4_inputContainer.classList.remove("div-none"),
      a4_selectorReview(a4_areaCalculatorSelector.value),
      (result.innerText = "");
  });
let a5_areaCalculatorSelector =
    document.querySelector(".area-5 .area-calculator") || null,
  a5_inputContainer = document.querySelector(".area-5 .inputContainer") || null,
  a5_inputOne = document.querySelector(".area-5 .inputOne") || null,
  a5_inputTwo = document.querySelector(".area-5 .inputTwo") || null,
  a5_singleSqrFt =
    document.querySelector(".area-5 .single-area-coverage") || null,
  a5_singleSqrFtSpan =
    document.querySelector(".area-5 .single-area-coverage span") || null;
function selectorReview(e) {
  (inputOne.querySelector("input").disabled = !1),
    (inputTwo.querySelector("input").disabled = !1),
    "circle" == e
      ? circleInputConfig()
      : "rectangle" == e
      ? rectangleInputConfig()
      : "square" == e && squareInputConfig();
}
function a2_selectorReview(e) {
  (a2_inputOne.querySelector("input").disabled = !1),
    (a2_inputTwo.querySelector("input").disabled = !1),
    "circle" == e
      ? a2_circleInputConfig()
      : "rectangle" == e
      ? a2_rectangleInputConfig()
      : "square" == e && a2_squareInputConfig();
}
function a3_selectorReview(e) {
  (a3_inputOne.querySelector("input").disabled = !1),
    (a3_inputTwo.querySelector("input").disabled = !1),
    "circle" == e
      ? a3_circleInputConfig()
      : "rectangle" == e
      ? a3_rectangleInputConfig()
      : "square" == e && a3_squareInputConfig();
}
function a4_selectorReview(e) {
  (a4_inputOne.querySelector("input").disabled = !1),
    (a4_inputTwo.querySelector("input").disabled = !1),
    "circle" == e
      ? a4_circleInputConfig()
      : "rectangle" == e
      ? a4_rectangleInputConfig()
      : "square" == e && a4_squareInputConfig();
}
function a5_selectorReview(e) {
  (a5_inputOne.querySelector("input").disabled = !1),
    (a5_inputTwo.querySelector("input").disabled = !1),
    "circle" == e
      ? a5_circleInputConfig()
      : "rectangle" == e
      ? a5_rectangleInputConfig()
      : "square" == e && a5_squareInputConfig();
}
function resetData() {
  document.querySelectorAll("#product-lists select").forEach((e) => {
    e.value = "";
  }),
    null != document.querySelector("#collection-list select") &&
      (document.querySelector("#collection-list select").value = ""),
    null != document.querySelector("#calc_depth") &&
      (document.querySelector("#calc_depth").value = ""),
    (areaCalculatorSelector.value = ""),
    (a2_areaCalculatorSelector.value = ""),
    (a3_areaCalculatorSelector.value = ""),
    (a4_areaCalculatorSelector.value = ""),
    (a5_areaCalculatorSelector.value = ""),
    (inputOne.querySelector("input").value = ""),
    (inputTwo.querySelector("input").value = ""),
    (a2_inputOne.querySelector("input").value = ""),
    (a2_inputTwo.querySelector("input").value = ""),
    (a3_inputOne.querySelector("input").value = ""),
    (a3_inputTwo.querySelector("input").value = ""),
    (a4_inputOne.querySelector("input").value = ""),
    (a4_inputTwo.querySelector("input").value = ""),
    (a5_inputOne.querySelector("input").value = ""),
    (a5_inputTwo.querySelector("input").value = ""),
    !singleSqrFt.classList.contains("div-none") &&
      singleSqrFt.classList.add("div-none"),
    !a2_singleSqrFt.classList.contains("div-none") &&
      a2_singleSqrFt.classList.add("div-none"),
    !a3_singleSqrFt.classList.contains("div-none") &&
      a3_singleSqrFt.classList.add("div-none"),
    !a4_singleSqrFt.classList.contains("div-none") &&
      a4_singleSqrFt.classList.add("div-none"),
    !a5_singleSqrFt.classList.contains("div-none") &&
      a5_singleSqrFt.classList.add("div-none");
}
function circleInputConfig() {
  (inputOne.querySelector("label").innerText = "Diameter"),
    inputTwo.classList.contains("div-none") ||
      inputTwo.classList.add("div-none"),
    (inputTwo.querySelector("input").disabled = "disabled");
}
function rectangleInputConfig() {
  (inputOne.querySelector("label").innerText = "Length"),
    (inputTwo.querySelector("label").innerText = "Width"),
    inputTwo.classList.contains("div-none") &&
      (inputTwo.classList.remove("div-none"),
      (inputTwo.querySelector("input").disabled = ""));
}
function squareInputConfig() {
  (inputOne.querySelector("label").innerText = "Length"),
    inputTwo.classList.contains("div-none") ||
      inputTwo.classList.add("div-none"),
    (inputTwo.querySelector("input").disabled = "disabled");
}
function a2_circleInputConfig() {
  (a2_inputOne.querySelector("label").innerText = "Diameter"),
    a2_inputTwo.classList.contains("div-none") ||
      a2_inputTwo.classList.add("div-none"),
    (a2_inputTwo.querySelector("input").disabled = "disabled");
}
function a2_rectangleInputConfig() {
  (a2_inputOne.querySelector("label").innerText = "Length"),
    (a2_inputTwo.querySelector("label").innerText = "Width"),
    a2_inputTwo.classList.contains("div-none") &&
      (a2_inputTwo.classList.remove("div-none"),
      (a2_inputTwo.querySelector("input").disabled = ""));
}
function a2_squareInputConfig() {
  (a2_inputOne.querySelector("label").innerText = "Length"),
    a2_inputTwo.classList.contains("div-none") ||
      a2_inputTwo.classList.add("div-none"),
    (a2_inputTwo.querySelector("input").disabled = "disabled");
}
function a3_circleInputConfig() {
  (a3_inputOne.querySelector("label").innerText = "Diameter"),
    a3_inputTwo.classList.contains("div-none") ||
      a3_inputTwo.classList.add("div-none"),
    (a3_inputTwo.querySelector("input").disabled = "disabled");
}
function a3_rectangleInputConfig() {
  (a3_inputOne.querySelector("label").innerText = "Length"),
    (a3_inputTwo.querySelector("label").innerText = "Width"),
    a3_inputTwo.classList.contains("div-none") &&
      (a3_inputTwo.classList.remove("div-none"),
      (a3_inputTwo.querySelector("input").disabled = ""));
}
function a3_squareInputConfig() {
  (a3_inputOne.querySelector("label").innerText = "Length"),
    a3_inputTwo.classList.contains("div-none") ||
      a3_inputTwo.classList.add("div-none"),
    (a3_inputTwo.querySelector("input").disabled = "disabled");
}
function a4_circleInputConfig() {
  (a4_inputOne.querySelector("label").innerText = "Diameter"),
    a4_inputTwo.classList.contains("div-none") ||
      a4_inputTwo.classList.add("div-none"),
    (a4_inputTwo.querySelector("input").disabled = "disabled");
}
function a4_rectangleInputConfig() {
  (a4_inputOne.querySelector("label").innerText = "Length"),
    (a4_inputTwo.querySelector("label").innerText = "Width"),
    a4_inputTwo.classList.contains("div-none") &&
      (a4_inputTwo.classList.remove("div-none"),
      (a4_inputTwo.querySelector("input").disabled = ""));
}
function a4_squareInputConfig() {
  (a4_inputOne.querySelector("label").innerText = "Length"),
    a4_inputTwo.classList.contains("div-none") ||
      a4_inputTwo.classList.add("div-none"),
    (a4_inputTwo.querySelector("input").disabled = "disabled");
}
function a5_circleInputConfig() {
  (a5_inputOne.querySelector("label").innerText = "Diameter"),
    a5_inputTwo.classList.contains("div-none") ||
      a5_inputTwo.classList.add("div-none"),
    (a5_inputTwo.querySelector("input").disabled = "disabled");
}
function a5_rectangleInputConfig() {
  (a5_inputOne.querySelector("label").innerText = "Length"),
    (a5_inputTwo.querySelector("label").innerText = "Width"),
    a5_inputTwo.classList.contains("div-none") &&
      (a5_inputTwo.classList.remove("div-none"),
      (a5_inputTwo.querySelector("input").disabled = ""));
}
function a5_squareInputConfig() {
  (a5_inputOne.querySelector("label").innerText = "Length"),
    a5_inputTwo.classList.contains("div-none") ||
      a5_inputTwo.classList.add("div-none"),
    (a5_inputTwo.querySelector("input").disabled = "disabled");
}
function square(e, n) {
  return +e * +n;
}
function circle(e) {
  let n = +e / 2;
  return 3.14 * Math.pow(+n, 2);
}
null != a5_areaCalculatorSelector &&
  a5_areaCalculatorSelector.addEventListener("change", () => {
    a5_inputContainer.classList.contains("div-none") &&
      a5_inputContainer.classList.remove("div-none"),
      a5_selectorReview(a5_areaCalculatorSelector.value),
      (result.innerText = "");
  }),
  calcForm.addEventListener("submit", (e) => {
    e.preventDefault();
    let n,
      t,
      a = areaCalculatorSelector.value,
      l = document.querySelector("#calc_depth"),
      r = document.querySelector("#collection-list select") || null;
    if (null != r) {
      if (null == r.value || "" == r.value)
        return void r.classList.add("border-danger");
      r.classList.contains("border-danger") &&
        r.classList.remove("border-danger");
    }
    let i = document.querySelectorAll("#product-lists select") || null;
    if (
      (i.forEach((e) => {
        null == e.value || "" == e.value
          ? e.classList.add("border-danger")
          : e.classList.contains("border-danger") &&
            e.classList.remove("border-danger");
      }),
      "circle" == a
        ? (n = circle(inputOne.querySelector("input").value))
        : "rectangle" == a
        ? (n = square(
            inputOne.querySelector("input").value,
            inputTwo.querySelector("input").value
          ))
        : "square" == a &&
          (n = square(
            inputOne.querySelector("input").value,
            inputOne.querySelector("input").value
          )),
      isNaN(n) && (n = 0),
      (t = n * (+l.value / 12)),
      null != singleSqrFt &&
        0 != n &&
        (singleSqrFt.classList.contains("div-none") &&
          singleSqrFt.classList.remove("div-none"),
        (singleSqrFtSpan.innerText = n)),
      null != a2_areaCalculatorSelector)
    ) {
      let e,
        n = a2_areaCalculatorSelector.value;
      "" != n.value &&
        ("circle" == n
          ? (e = circle(a2_inputOne.querySelector("input").value))
          : "rectangle" == n
          ? (e = square(
              a2_inputOne.querySelector("input").value,
              a2_inputTwo.querySelector("input").value
            ))
          : "square" == n &&
            (e = square(
              a2_inputOne.querySelector("input").value,
              a2_inputOne.querySelector("input").value
            )),
        isNaN(e) && (e = 0),
        (t = e * (+l.value / 12) + t),
        null != a2_singleSqrFt &&
          0 != e &&
          (a2_singleSqrFt.classList.contains("div-none") &&
            a2_singleSqrFt.classList.remove("div-none"),
          (a2_singleSqrFtSpan.innerText = e)));
    }
    if (null != a3_areaCalculatorSelector) {
      let e,
        n = a3_areaCalculatorSelector.value;
      "" != n.value &&
        ("circle" == n
          ? (e = circle(a3_inputOne.querySelector("input").value))
          : "rectangle" == n
          ? (e = square(
              a3_inputOne.querySelector("input").value,
              a3_inputTwo.querySelector("input").value
            ))
          : "square" == n &&
            (e = square(
              a3_inputOne.querySelector("input").value,
              a3_inputOne.querySelector("input").value
            )),
        isNaN(e) && (e = 0),
        (t = e * (+l.value / 12) + t),
        null != a3_singleSqrFt &&
          0 != e &&
          (a3_singleSqrFt.classList.contains("div-none") &&
            a3_singleSqrFt.classList.remove("div-none"),
          (a3_singleSqrFtSpan.innerText = e)));
    }
    if (null != a4_areaCalculatorSelector) {
      let e,
        n = a4_areaCalculatorSelector.value;
      "" != n.value &&
        ("circle" == n
          ? (e = circle(a4_inputOne.querySelector("input").value))
          : "rectangle" == n
          ? (e = square(
              a4_inputOne.querySelector("input").value,
              a4_inputTwo.querySelector("input").value
            ))
          : "square" == n &&
            (e = square(
              a4_inputOne.querySelector("input").value,
              a4_inputOne.querySelector("input").value
            )),
        isNaN(e) && (e = 0),
        (t = e * (+l.value / 12) + t),
        null != a4_singleSqrFt &&
          0 != e &&
          (a4_singleSqrFt.classList.contains("div-none") &&
            a4_singleSqrFt.classList.remove("div-none"),
          (a4_singleSqrFtSpan.innerText = e)));
    }
    if (null != a5_areaCalculatorSelector) {
      let e,
        n = a5_areaCalculatorSelector.value;
      "" != n.value &&
        ("circle" == n
          ? (e = circle(a5_inputOne.querySelector("input").value))
          : "rectangle" == n
          ? (e = square(
              a5_inputOne.querySelector("input").value,
              a5_inputTwo.querySelector("input").value
            ))
          : "square" == n &&
            (e = square(
              a5_inputOne.querySelector("input").value,
              a5_inputOne.querySelector("input").value
            )),
        isNaN(e) && (e = 0),
        (t = e * (+l.value / 12) + t),
        null != a5_singleSqrFt &&
          0 != e &&
          (a5_singleSqrFt.classList.contains("div-none") &&
            a5_singleSqrFt.classList.remove("div-none"),
          (a5_singleSqrFtSpan.innerText = e)));
    }
    (result.innerText = t), console.log("total coverage");
    let u = document.querySelector(".total-area-coverage span") || null;
    if (null != u) {
      let e = 0;
      if (
        (document
          .querySelectorAll(".single-area-coverage span")
          .forEach((n) => {
            n.innerText.length > 0 && (e += +n.innerText);
          }),
        (u.innerText = e.toFixed(2)),
        console.log("totalCov: ", u.innerText),
        "0.00" == u.innerText)
      )
        return void console.log("its 0");
    }
    null != document.querySelector(".calculator--pdp-modal-input") &&
      (hidePdpCalc(), pdpPopulateData());
  });
let addExtraBtn = document.querySelector("#add-extra") || null;
if (null !== addExtraBtn) {
  function addExtraArea(e) {
    e.preventDefault();
    let n = document.querySelectorAll(".area-calc.div-none");
    n.length > 0 &&
      (n[0].classList.remove("div-none"),
      console.log(n.length),
      1 === n.length && addExtraBtn.classList.add("div-none"));
  }
  addExtraBtn.addEventListener("click", addExtraArea, !1);
}
document.addEventListener("DOMContentLoaded", function () {
  const e = document.querySelector('.quantity__button[name="minus"]'),
    n = document.querySelector('.quantity__button[name="plus"]'),
    t = document.querySelector(".quantity__input");
  e.addEventListener("click", function () {
    let e = parseInt(t.value);
    e > 1 && (t.value = e - 1);
  }),
    n.addEventListener("click", function () {
      let e = parseInt(t.value);
      t.value = e + 1;
    });
});
let fetchedData,
  atcForm = document.querySelector("form#greencycle-calc");
function displayCalc() {
  let e = document.querySelector(".calc-block#blank"),
    n = document.querySelector(".calc-block#calculated");
  !e.classList.contains("div-none") && e.classList.add("div-none"),
    n.classList.contains("div-none") && n.classList.remove("div-none");
}
function hideCalc() {
  let e = document.querySelector(".calc-block#blank"),
    n = document.querySelector(".calc-block#calculated");
  e.classList.contains("div-none") && e.classList.remove("div-none"),
    !n.classList.contains("div-none") && n.classList.add("div-none");
}
function populateData(e) {
  let n,
    t = e.featured_image;
  console.log(t),
    t
      ? t.includes(".jpg")
        ? (n = t.replace(".jpg", ".jpg"))
        : t.includes(".jpeg")
        ? (n = t.replace(".jpeg", ".jpeg"))
        : t.includes(".png")
        ? (n = t.replace(".png", ".png"))
        : t.includes(".gif") && (n = t.replace(".gif", ".gif"))
      : (n =
          "https://cdn.shopify.com/s/files/1/0749/0315/9076/files/placeholder-images-image_large_a8b8694a-c744-44c0-9fde-250795c1b160.webp?v=1707905591");
  let a = e.title,
    l = e.price,
    r = document.querySelector("#calculated .product-display .image img"),
    i = document.querySelector("#calculated .product-display .data .title"),
    u = document.querySelector("#calculated .product-display .price"),
    o = document.querySelector(".cubic-yards span"),
    c = parseFloat(document.querySelector("#result p").innerText),
    s = document.querySelector(".mulch-bags span");
  (o.innerText = (c / 27).toFixed(2)),
    (s.innerText = Math.ceil(c / 2)),
    (r.src = n),
    (r.alt = a),
    (i.innerText = a);
  let d = Math.ceil(c / 27);
  u.innerText = `$${((l * d) / 100).toFixed(2)}`;
  let p = fetchedData.variants[0].id,
    S = document.querySelector("quantity-input #Quantity-template--calculator"),
    q = document.querySelector(
      '#product-form-template--calculator input[name="id"]'
    );
  (S.value = d), (q.value = p);
}
jQuery("#AddToCart").click(function myId(e) {
  e.preventDefault();
  Shopify.addItemFromFormStart("product-form-template--calculator", e.id);
  console.log(e.id);
});
atcForm.addEventListener("submit", (e) => {
  e.preventDefault();
  let n = `https://${Shopify.shop}/products/${selectedOption.value}.js`;
  fetch(n)
    .then((e) => e.json())
    .then((e) => {
      (fetchedData = e),
        setTimeout(function () {
          displayCalc();
        }, 1e3),
        console.log(fetchedData),
        populateData(fetchedData);
      myId(myid);
    });
});
